import { z } from "zod";

/** Freshness of the Postgres rows a listing was served from; `synced_at` null and no `failure` means the first sync is still queued. */
export const GithubSnapshot = z
  .object({
    synced_at: z.string().nullable(),
    attempted_at: z.string().nullable(),
    failure: z.string().nullable(),
  })
  .optional();
export type GithubSnapshot = z.infer<typeof GithubSnapshot>;

const SYNC_POLL_MS = 1000;
const SYNC_POLL_WINDOW_MS = 5 * 60 * 1000;

/**
 * `refetchInterval` for a query whose response carries `snapshot`: poll while a sync queued in the last five minutes
 * has neither landed nor failed. A pair nothing ever queued for (no token, nothing to sync) is served as is.
 */
export function pollWhileSyncing<T extends { snapshot?: GithubSnapshot }>(
  data: T | undefined,
): number | false {
  const snapshot = data?.snapshot;
  if (
    !snapshot ||
    snapshot.synced_at !== null ||
    snapshot.failure !== null ||
    snapshot.attempted_at === null
  ) {
    return false;
  }
  return Date.now() - new Date(snapshot.attempted_at).getTime() <
    SYNC_POLL_WINDOW_MS
    ? SYNC_POLL_MS
    : false;
}
